import addValidationMessage from '../utils/translation/addValidationMessage';

addValidationMessage('Core/maxFilesValidator', 'maxFiles', {
  fr: 'Maximum {{maxFiles}} fichier{{plural}}, veuillez enlever {{diff}} fichier{{diffPlural}}',
  en: 'Maximum {{maxFiles}} files{{plural}}, please remove {{diff}} file{{diffPlural}}',
});

const maxFilesValidator = (value: File[], { maxFiles }: { maxFiles: number}) => (
  !Array.isArray(value) ||
  value.length <= maxFiles
);

maxFilesValidator.computed = (value: File[], { maxFiles }: { maxFiles: number}) => ({
  diff: (value?.length || 0) - maxFiles,
  plural: maxFiles > 1 ? 's' : '',
  diffPlural: (value?.length || 0) - maxFiles > 1 ? 's' : '',
});

/**
 * @component
 * @visibleName maxFilesValidator
 */
export default maxFilesValidator;
